import React from 'react';
import { Table } from '@shared/components/ui/Table';
import { SubjectTag } from '@shared/components/ui/SubjectTag';
import dayjs from 'dayjs';

export const TableProcessed = (props) => {
  const {
    data
  } = props;

  const columns = [
    {
      name: 'id',
      label: 'ID',
      options: {
        filter: false,
        sort: true,
        display: false,
      },
    },
    {
      name: 'submitted_at',
      label: 'Date',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => dayjs(value).format('DD/MM/YYYY HH:mm'),
      },
    },
    {
      name: 'status',
      label: 'Statut',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          if (value && value.name) {
            return value.name;
          }
          return '-';
        },
      },
    },
    {
      name: 'studentInfo',
      label: 'Élève',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'type',
      label: 'Type',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'level_name',
      label: 'Niveau',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'level_group',
      label: 'Niveau',
      options: {
        filter: true,
        sort: false,
        display: 'excluded',
      },
    },
    {
      name: 'subject',
      label: 'Matière',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => <SubjectTag text={value} />,
      },
    },
    {
      name: 'special',
      label: 'Special',
      options: {
        filter: true,
        sort: true,
        filterType: 'dropdown',
        customFilterListOptions: {
          render: (value) => {
            if (value === 0) return '-';
            if (value === 1) return "Documentaliste";
            if (value === 2) return "Grand Oral";
          },
        },
        filterOptions: {
          renderValue: value => {
            if (value === 0) return '-';
            if (value === 1) return "Documentaliste";
            if (value === 2) return "Grand Oral";
          }
        },
        customBodyRender: (value, tableMeta, updateValue) => {
          if (value === 1)
            return <SubjectTag text="Documentaliste" />

          if (value === 2)
            return <SubjectTag text="Grand Oral" />

          return "-";
        }
      },
    },
    {
      name: 'picked_by_switchman_time',
      label: 'Délai aiguilleur',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'switchmanInfo',
      label: 'Aiguilleur',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'picked_by_teacher_time',
      label: 'Délai enseignant',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'teacherInfo',
      label: 'Enseignant',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'succeed_time',
      label: 'Délai succès',
      options: {
        filter: false,
        sort: true,
      },
    },
  ];

  return <Table title={'Requêtes traitées'} data={data} columns={columns} />;
};
